import CustomFastImage from 'design-system/src/Components/CustomFastImage/CustomFastImage';
import Metrics from 'design-system/src/Theme/Metrics';
import {
  ILiveEventFragmentFragment,
  ILiveEventsPageFragmentFragment,
} from '~Api/Graphql/gql/types.generated';
import {isElementRestricted} from '~Api/Graphql/links/utils/isElementRestricted';
import {ICategorySliderItem} from '~Umbraco/Components/CategorySlider/CategorySlider';
import React from 'react';
import {TFunction} from 'i18next';

export const mapLiveEventsPage = (
  category: ILiveEventsPageFragmentFragment,
  canSeeContent: (
    accessType?: ILiveEventFragmentFragment['accessType'],
  ) => boolean,
  t: TFunction<'translation', undefined, 'translation'>,
): ICategorySliderItem[] => {
  // const {t} = i18n;
  const {liveEventsContent} = category;
  const items: ICategorySliderItem[] = [];
  liveEventsContent?.forEach(item => {
    if (item && !isElementRestricted(item)) {
      switch (item.__typename) {
        case 'LiveEvent':
          const {
            title,
            thumbnail,
            name,
            subtitle,
            url,
            __typename,
            id,
            channel,
          } = item;
          url &&
            url !== '#' &&
            items.push({
              url: url || '',
              title: title || name || '',
              subtitle: subtitle || '',
              logo:
                channel && channel.__typename === 'Channel' && channel.logo ? (
                  <CustomFastImage
                    source={{uri: channel.logo.url}}
                    width={Metrics.horizontalScale(80)}
                    height={Metrics.verticalScale(55)}
                  />
                ) : undefined,
              cover: thumbnail
                ? {
                    uri: thumbnail.url,
                  }
                : undefined,
              tag: {
                variant: 'live',
                text: t('Live Tv'),
              },
              extraContent: undefined,
              __typename,
              id,
              accessData: {
                accessType: item.accessType,
                paywall: item.paywall,
              },
              isFreemium: canSeeContent(item.accessType),
            } as ICategorySliderItem);
          break;

        default:
          break;
      }
    }
  });

  return items;
};
